<template>
  <div class="td-doctor-info">
    <td-divider style="margin-top:100px;" v-if="user.AuditStatus===0">您的资料正在审核中...</td-divider>
    <div style="margin-top:100px;" class="ddd" v-if="user.AuditStatus===1">
      <p>您的资料未审核通过。</p>
      <p>原因：{{user.Remark}}</p>
    </div>
    <div class="btnSubmit" style="text-align:center;margin-top:20px;">
      <el-button
        type="primary"
        class="td-btn-doctor-primary"
        style="width:80%;"
        round
        @click.native="$router.push({name:'tdDoctorMeBaseInfo'})"
      >修改认证信息</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TianDingDoctorInfoComponent",
  data() {
    return {
      user: {}
    };
  },
  mounted() {
    this.user = JSON.parse(this.local$.getItem("tdUser"));
  }
};
</script>

<style lang="scss" scoped>
.td-doctor-info {
  .ddd {
    p {
      display: block;
      text-align: center;
      color: #666;
      padding: 0 10px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/others/info.vue